import { ButtonGroup, Stack } from '@mui/material'
import { useUser } from '@/features/auth/hooks/useUser'
import { AddToCollection } from './selection/AddToCollection'
import { BulkEditSelected } from './selection/BulkEditSelected'
import ManageSelection from './selection/ManageSelection'

type Props = {}
export const SelectionActions = (props: Props) => {
  const {
    selectors: { selectUserRights },
  } = useUser()

  const { canBulkEdit } = selectUserRights()

  return (
    <Stack direction="row" spacing={0.5}>
      <ManageSelection />
      <ButtonGroup variant="outlined" color="secondary">
        <AddToCollection />
        {canBulkEdit ? <BulkEditSelected /> : null}
      </ButtonGroup>
    </Stack>
  )
}
